import React, {Component} from 'react';
import moment from 'moment-timezone';
import Clock from './components/Clock';

import getAngles from './helpers/getAngles';

export default class ClockComponent extends Component {
    constructor() {
        super();
        this.state = {
            time: moment(),
            timezone: null,
        };

        this.getTime = this.getTime.bind(this);
    }

    componentDidMount() {
        const select = document.getElementById('user_settings_timezone');
        const _this = this;
        this.setState({
            timezone: select.value,
            time: moment.tz(Date.now(), select.value)
        });
        select.addEventListener("change", function (e) {
            _this.setState({
                ..._this.state,
                timezone: e.target.value
            })
        });
        setInterval(this.getTime, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.getTime)
    }

    getTime() {
        this.setState({
            ...this.state,
            time: moment.tz(Date.now(), this.state.timezone)
        })
    }

    getPrefixedTime(value) {
        return value.toString().length < 2 ? "0" + value : value
    }

    render() {
        const {time} = this.state;
        const angles = getAngles(time)
        const minutes = time.minute();
        const hours = time.hour();
        return (
        <div>
            <Clock minutesAngle={angles.minutesAngle}
                   hoursAngle={angles.hoursAngle}
                   secondsAngle={angles.secondsAngle}/>
            <p className="c-set-timezone__time">{this.getPrefixedTime(hours)}:{this.getPrefixedTime(minutes)}</p>
        </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/ClockComponent/ClockComponent.jsx